<!-- -->
<template>
  <div :class="{ frame: true, 'm-frame': isMobile }">
    <div id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
          <a
            :href="item.hrefUrl"
            target="_blank"
            rel="noopener noreferrer"
            v-if="item.hrefUrl"
          >
            <img class="banner" :src="URL + item.bannerUrl" />
          </a>
          <img class="banner" :src="URL + item.bannerUrl" v-else />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="box service">
      <div class="title-box">
        <!-- <div class="title">OUR SERVICES</div> -->
        <img
          src="http://gxbg.pangodso.com/file/static/title-service.png"
          alt=""
          class="title-img"
        />
        <div class="sub">我们的服务</div>
      </div>
      <div class="list" id="service">
        <div class="swiper-wrapper">
          <div class="item swiper-slide" style="padding: 0 35px">
            <img :src="URL + 'business_search.png'" alt="" />
            <div class="title">百度搜索</div>
            <div class="tip">
              根据客户主动搜索，展示您的推广内容，精准定位，性价比高
            </div>
            <router-link to="/business/Search">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide" style="padding: 0 27px">
            <img :src="URL + 'business_info.png'" alt="" />
            <div class="title">百度信息流</div>
            <div class="tip">
              将您的推广信息自然融入在各类资讯、信息中，易传播，易操作
            </div>
            <router-link to="/business/Info">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide" style="padding: 0 41px">
            <img :src="URL + 'business_brand.png'" alt="" />
            <div class="title">百度品牌专区</div>
            <div class="tip">
              品牌专区，快速建立您的企业品牌公信力，首位霸屏，强展现
            </div>
            <router-link to="/business/Brand">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide" style="padding: 0 21px">
            <img :src="URL + 'business_aicaigou.png'" alt="" />
            <div class="title">百度爱采购</div>
            <div class="tip">
              从搜索到代运营，一站式满足客户需求，真正帮助企业解决【卖货】营销难题
            </div>
            <router-link to="/business/Aicaigou">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide" style="padding: 0 23px">
            <img :src="URL + 'business_ad.png'" alt="" />
            <div class="title">百度开屏广告</div>
            <div class="tip">
              百度开屏矩阵，是以围绕百度APP搭建的百度系开屏产品矩阵
            </div>
            <router-link to="/business/Ad">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide">
            <img :src="geoIcon" alt="" />
            <div class="title">GEO服务</div>
            <div class="tip">
              AI 时代全新营销方式，在大模型平台抢占问答入口，实现全平台精准获客
            </div>
            <router-link to="/business/Geo">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide">
            <img :src="URL + 'business_redBook.png'" alt="" />
            <div class="title">小红书</div>
            <div class="tip">
              中国最大的生活方式平台，满足广告主多样化营销诉求
            </div>
            <router-link to="/business/RedBook">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
          <div class="item swiper-slide">
            <img :src="URL + 'business_web.png'" alt="" />
            <div class="title">网站建设</div>
            <div class="tip">
              帮助企业宣传形象、展示风采、推出产品，更轻松快速地开展互联网营销
            </div>
            <router-link to="/business/Web">
              <button class="btn">查看详情</button>
            </router-link>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="box intro">
      <div class="title-box">
        <!-- <div class="title">ABOUT US</div> -->
        <img
          src="http://gxbg.pangodso.com/file/static/title-about.png"
          alt=""
          class="title-img"
        />
        <div class="sub">公司介绍</div>
      </div>
      <div class="intro-box" v-if="!isMobile">
        <div class="name">广西盘古百桂广告有限公司</div>
        <div class="desc">
          广西盘古百桂广告有限公司（简称广西盘古）为盘古广告旗下子公司，于2024年4月应市场发展之需在广西正式成立。
          <br />
          广西盘古秉承盘古广告品牌愿景，致力于成为一家顶尖的互联网专业服务商并永续发展，成为一家勇于承担社会责任并有人情味的企业。目前，公司与国内知名互联网公司达成深度合作，成为百度公司广西南宁地区的独家代理商、深度云海广西地区代理商。同时，广西盘古持续拓展业务版图，精进专业能力与服务品质，着力塑造卓越服务品牌与企业形象，在客户群体中树立了良好口碑与广泛知名度。
        </div>
        <button class="more" @click="navTo('/intro')">查看更多 ></button>
      </div>
      <div class="intro-box m-intro-box" v-else>
        <div class="name">关于盘古百桂</div>
        <div class="desc">
          广西盘古百桂广告有限公司（简称广西盘古）为盘古广告旗下子公司。2024年4月，顺应市场发展需求，广西盘古在广西应运而生...
        </div>
        <button class="more" @click="navTo('/intro')">查看更多 ></button>
      </div>
    </div>
    <div class="power" ref="powerRef">
      <div class="title-box">
        <img
          src="http://gxbg.pangodso.com/file/static/title-size.png"
          alt=""
          class="title-img"
        />
        <div class="sub">集团规模</div>
      </div>
      <div class="content">
        <div class="item">
          <div class="count">
            <countTo
              ref="count1"
              :startVal="0"
              :endVal="yearNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            年
          </div>
          <div class="type">广告经验</div>
        </div>
        <div class="item">
          <div class="count">
            <countTo
              ref="count2"
              :startVal="0"
              :endVal="teamNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            <span class="topUnit">+</span>
            人
          </div>
          <div class="type">服务团队</div>
        </div>
        <div class="item">
          <div class="count">
            <countTo
              ref="count3"
              :startVal="0"
              :endVal="memberNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            <span class="topUnit">+</span>
          </div>
          <div class="type">合作客户</div>
        </div>
        <div class="item">
          <div class="count">
            <countTo
              ref="count4"
              :startVal="0"
              :endVal="areaNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            <span class="topUnit">+</span>
            ㎡
          </div>
          <div class="type">甲级写字楼</div>
        </div>
        <div class="dot"></div>
      </div>
    </div>
    <div class="box cert">
      <img :src="URL + 'static/cert_bg.jpg'" alt="" class="cert-bg" />
      <div class="in">
        <div class="title-box">
          <img
            src="http://gxbg.pangodso.com/file/static/title-qualifications.png"
            alt=""
            class="title-img"
          />
          <div class="sub">企业资质</div>
        </div>
      </div>
      <div class="cert-imgs">
        <imageSlider />
      </div>
    </div>
    <div class="box value">
      <div class="in">
        <div class="left">
          <div
            :class="{ tab: true, active: activeTab == 0 }"
            @pointerenter="changeTab(0)"
          >
            <span>企业<br />使命</span>
            <img src="@/assets/value_icon.png" alt="" class="icon" />
          </div>
          <div
            :class="{ tab: true, active: activeTab == 1 }"
            @pointerenter="changeTab(1)"
          >
            <span>企业<br />愿景</span>
            <img src="@/assets/value_icon.png" alt="" class="icon" />
          </div>
          <div
            :class="{ tab: true, active: activeTab == 2 }"
            @pointerenter="changeTab(2)"
          >
            <span>企业<br />价值观</span>
            <img src="@/assets/value_icon.png" alt="" class="icon" />
          </div>
        </div>
        <div class="right">
          <div class="tab_content" v-show="activeTab == 0">
            <div class="title">我们的使命</div>
            <div class="sub">助力客户事业发展<br />成就员工人生价值</div>
            <button class="about" @click="navTo('/intro')">关于我们 ></button>
          </div>
          <div class="tab_content" v-show="activeTab == 1">
            <div class="title">我们的愿景</div>
            <div class="sub">
              成为一家顶尖的互联网广告服务商并永续发展<br />成为一家勇于承担社会责任并有人情味的企业
            </div>
            <button class="about" @click="navTo('/intro')">关于我们 ></button>
          </div>
          <div class="tab_content" v-show="activeTab == 2">
            <div class="title">我们的价值观</div>
            <div class="sub">
              正直诚信 敬业乐群 悦纳变化<br />令行禁止 只做第一 使命必达
            </div>
            <button class="about" @click="navTo('/intro')">关于我们 ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="box case">
      <div class="title-box">
        <img
          src="http://gxbg.pangodso.com/file/static/title-case.png"
          alt=""
          class="title-img"
        />
        <div class="sub">案例展示</div>
      </div>
      <div class="case-list" v-if="!isMobile">
        <div
          class="item"
          v-for="item in caseList"
          :key="item.id"
          @click="navToCaseDetail(item.id)"
        >
          <div class="good">优秀案例</div>
          <div class="post">
            <img :src="URL + item.newsImageUrl" alt="" />
          </div>
          <div class="bottom">
            <div class="title">{{ item.title }}</div>
            <div class="data" v-show="item.averageCrt">
              <img src="@/assets/icon_case_pointer.png" alt="" class="icon" />
              <div class="num">{{ item.averageCrt }}%</div>
            </div>
            <div class="data data2" v-show="item.exposureShow">
              <img src="@/assets/icon_case_push.png" alt="" class="icon" />
              <div class="num">{{ item.exposureShow }}W</div>
            </div>
          </div>
        </div>
      </div>
      <div class="case-list" v-else>
        <div id="case">
          <div class="swiper-wrapper">
            <div
              class="item swiper-slide"
              v-for="item in caseList"
              :key="item.id"
              @click="navToCaseDetail(item.id)"
            >
              <div class="good">优秀案例</div>
              <div class="post">
                <img :src="URL + item.newsImageUrl" alt="" />
              </div>
              <div class="bottom">
                <div class="title">{{ item.title }}</div>
                <div class="data" v-show="item.averageCrt">
                  <img
                    src="@/assets/icon_case_pointer.png"
                    alt=""
                    class="icon"
                  />
                  <div class="num">{{ item.averageCrt }}%</div>
                </div>
                <div class="data data2" v-show="item.exposureShow">
                  <img src="@/assets/icon_case_push.png" alt="" class="icon" />
                  <div class="num">{{ item.exposureShow }}W</div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <button class="more" @click="navTo('/case')">查看更多 ></button>
      </div>
    </div>
    <div class="box new">
      <div class="title-box">
        <!-- <div class="title">NEWS CENTER</div> -->
        <img
          src="http://gxbg.pangodso.com/file/static/title-new.png"
          alt=""
          class="title-img"
        />
        <div class="sub">新闻资讯</div>
      </div>
      <div class="content">
        <div id="news">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in newsList"
              :key="item.id"
              @click="navToNewDetail(item.id)"
            >
              <img class="banner" :src="URL + item.newsImageUrl" />
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="new-list" v-if="!isMobile">
          <div
            class="item"
            v-for="item in newsList"
            :key="item.id"
            @click="navToNewDetail(item.id)"
          >
            <div class="title">{{ item.title }}</div>
            <div class="time">
              {{ (item.publishTime || item.createTime) | handleTime }}
            </div>
          </div>
        </div>
        <div class="new-list" v-else>
          <div
            class="item"
            v-for="item in newsList"
            :key="item.id"
            @click="navToNewDetail(item.id)"
          >
            <img :src="URL + item.newsImageUrl" alt="" class="left" />
            <div class="right">
              <div class="title">{{ item.title }}</div>
              <div class="time">
                {{ (item.publishTime || item.createTime) | handleTime }}
              </div>
              <div class="desc">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box link">
      <div class="title-box">
        <img
          src="http://gxbg.pangodso.com/file/static/title-friendlink.png"
          alt=""
          class="title-img"
        />
        <div class="sub">集团及旗下公司</div>
      </div>
      <div class="content">
        <a
          class="item"
          :href="item.hrefUrl"
          target="_blank"
          v-for="item in friendlinkList"
          :key="item.id"
          >{{ item.name }}</a
        >
      </div>
    </div>
    <submit v-if="!isMobile" />
  </div>
</template>

<script>
import countTo from "vue-count-to";
import submit from "@/components/submit.vue";
import imageSlider from "@/components/imageSlider.vue";
import { URL } from "@/util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  components: {
    countTo,
    submit,
    imageSlider,
  },
  data() {
    return {
      URL,
      geoIcon: "./geo/icon.svg",
      bannerList: [],
      teamNum: 300,
      yearNum: 22,
      areaNum: 7900,
      memberNum: 50000,
      activeTab: 0, // 激活的使命价值观下标
      caseList: [],
      newsList: [],
      linkList: [], // 集团及旗下公司
    };
  },
  computed: {
    ...mapState(Store, ["isMobile", "friendlinkList"]),
  },
  created() {},
  mounted() {
    this.initYearNum();
    this.getBannerList();
    this.getCase();
    this.getNew();
    this.initService();
    this.$nextTick(() => {
      this.observerDom();
    });
  },
  beforeDestroy() {
    if (this.ob) {
      this.ob.disconnect();
      this.ob = null;
    }
    if (this.countTimer) {
      clearTimeout(this.countTimer);
      this.countTimer = null;
    }
  },
  methods: {
    initYearNum() {
      this.yearNum = new Date().getFullYear() - 2003;
    },
    async getBannerList() {
      let res = await this.$api.getBanner();
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBanner();
      }, 10);
    },
    initBanner() {
      new window.Swiper("#banner", {
        loop: true,
        autoplay: true,
        pagination: {
          el: "#banner .swiper-pagination",
        },
      });
    },
    initService() {
      let slidesCount = 4;
      // 手机端展示数量修改
      if (this.isMobile) {
        slidesCount = 2;
      }
      new window.Swiper("#service", {
        spaceBetween: 30,
        slidesPerView: slidesCount,
        pagination: {
          el: "#service .swiper-pagination",
        },
      });
    },
    // 监听页面滚动事件
    observerDom() {
      const box = this.$refs.powerRef;
      if (!box) return;
      this.ob = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.countTimer = setTimeout(() => {
            this.numIncrease();
          }, 600);
          this.ob.unobserve(box);
        }
      });
      this.ob.observe(box);
    },
    // 企业规模数字增长函数
    numIncrease() {
      this.$nextTick(() => {
        ["count1", "count2", "count3", "count4"].forEach((ref) => {
          const counter = this.$refs[ref];
          if (counter && typeof counter.start === "function") {
            counter.start();
          }
        });
      });
    },
    changeTab(idx) {
      this.activeTab = idx;
    },
    async getCase() {
      const params = {
        pageIndex: 1,
        pageSize: 3,
        goodExampleFlag: 1,
      };
      let res = await this.$api.getCaseList(params);
      this.caseList = res.data.list;

      if (this.isMobile) {
        setTimeout(() => {
          this.initCase();
        }, 10);
      }
    },
    initCase() {
      new window.Swiper("#case", {
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.5,
        pagination: {
          el: "#case .swiper-pagination",
        },
      });
    },
    async getNew() {
      let res = await this.$api.getAllNews();
      this.newsList = res.data;

      if (!this.isMobile) {
        setTimeout(() => {
          this.initNews();
        }, 10);
      }
    },
    initNews() {
      new window.Swiper("#news", {
        autoplay: true,
        pagination: {
          el: "#news .swiper-pagination",
        },
      });
    },
    navTo(path) {
      this.$router.push(path);
      window.scrollTo({ top: 0 });
    },
    navToCaseDetail(id) {
      this.$router.push("/caseDetail/" + id);
      window.scrollTo({ top: 0 });
    },
    navToNewDetail(id) {
      this.$router.push("/newDetail/" + id);
      window.scrollTo({ top: 0 });
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
$-width: 1200px;
#banner {
  width: 100%;
  height: 640px;
  overflow: hidden;
  position: relative;

  .banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.title-box {
  width: $-width;
  margin: 0 auto;
  color: $theme;

  &::after {
    content: "";
    display: block;
    width: 352px;
    height: 2px;
    background-color: $theme;
  }
  .title {
    font-size: 78px;
  }
  .title-img {
    height: 57px;
    width: auto;
  }
  .sub {
    font-size: 31px;
    margin-bottom: 14px;
    letter-spacing: 2px;
  }
}

.box {
  .intro-box {
    width: $-width;
    margin: 40px auto 0;

    .name {
      font-size: 23px;
      margin-bottom: 30px;
    }
    .desc {
      width: 620px;
      font-size: 14px;
      line-height: 23px;
    }
    .more {
      width: 180px;
      height: 40px;
      margin-top: 40px;
      font-size: 18px;
      background-color: $theme;
      color: #fff;
    }
  }
}
.service {
  padding: 100px 0 120px;
  background-color: #f6f8fa;

  .list {
    width: $-width;
    position: relative;
    overflow: hidden;
    margin: 60px auto 0;
    padding-bottom: 50px;
    cursor: grab;

    :deep(.swiper-pagination-bullet) {
      width: 15px;
      border-radius: 10px;
    }
    :deep(.swiper-pagination-bullet-active) {
      width: 30px;
    }

    .item {
      width: 277px;
      height: 330px;
      padding: 0 30px;
      box-sizing: border-box;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-bottom: 5px solid $theme;

      img {
        height: 60px;
      }
      .title {
        margin-top: 10px;
        margin-bottom: 30px;
        font-size: 25px;
      }
      .tip {
        height: 63px;
        font-size: 13px;
        line-height: 21px;
        text-align: center;
        margin-bottom: 30px;
      }
      .btn {
        width: 134px;
        padding: 8px 0;
        border-radius: 5px;
        background-color: $theme;
        color: #fff;
        font-size: 18px;
      }
    }
  }
}
.intro {
  padding: 100px 0 70px;
  background-image: url("http://gxbg.pangodso.com/file/static/intro_bg.png");
  background-size: cover;
  background-position: center -7rem;
}
.cert {
  position: relative;

  .cert-bg {
    width: 100%;
    min-height: 1063px;
    object-fit: cover;
    object-position: right;
    display: block;
  }
  .cert-imgs {
    display: none;
  }
  .in {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding: 100px 0 70px;
  }
}
.value {
  height: 590px;
  background-image: url("http://gxbg.pangodso.com/file/static/value_bg.png");
  background-size: cover;
  background-position-x: center;

  .in {
    width: $-width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;

    .left {
      width: 223px;
      height: 100%;
      display: flex;
      flex-direction: column;

      .tab {
        flex: 1;
        padding: 25px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: rgba($color: #000, $alpha: 0.5);
        cursor: pointer;

        span {
          color: #fff;
          font-size: 30px;
        }
        .icon {
          width: 27px;
        }
      }
      .active {
        background-color: rgba($color: $theme, $alpha: 0.5);
      }
    }
    .right {
      flex-grow: 1;
      margin-left: 90px;

      .tab_content {
        color: #fff;
        animation: fadeIn 0.5s;

        .title {
          font-size: 30px;
          margin-bottom: 20px;
        }
        .sub {
          font-size: 40px;
          margin-bottom: 32px;
          font-weight: bold;
        }
        .about {
          width: 180px;
          height: 40px;
          color: #fff;
          font-size: 18px;
          background-color: $theme;
        }
      }
    }
  }
}
.power {
  padding: 80px 0 100px;
  box-shadow: 0 10px 16px rgba($color: #0454d8, $alpha: 0.11);
  position: relative;
  z-index: 2;

  .content {
    width: $-width;
    height: 75px;
    margin: 100px auto 0;
    display: flex;

    .dot {
      width: 4px;
      height: 4px;
      background-color: $theme;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: none;
    }
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &:not(:first-child) {
        border-left: 3px solid $theme;
      }
      .count {
        font-size: 21px;

        span {
          color: $theme;
          font-size: 58px;
          font-weight: bold;
        }
        .topUnit {
          vertical-align: top;
          font-size: 22px;
          color: #000;
        }
      }
      .type {
        font-size: 18px;
      }
    }
  }
}
#case {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.case {
  padding: 100px 0 170px;

  .case-list {
    width: $-width;
    margin: 50px auto 0;
    display: flex;

    .item {
      width: 360px;
      border-bottom: 5px solid $theme;
      border-radius: 15px;
      overflow: hidden;
      box-shadow: 8px 13px 30px rgba(0, 0, 0, 0.15);
      transition: transform 0.5s;
      position: relative;
      cursor: pointer;

      &:hover {
        transform: translateY(-10px);
      }
      & + .item {
        margin-left: 60px;
      }
      .good {
        width: 100px;
        height: 40px;
        color: #fff;
        font-size: 17px;
        text-align: center;
        line-height: 40px;
        border-bottom-right-radius: 15px;
        box-shadow: 2px 3px 6px rgba($color: #444444, $alpha: 0.81);
        background-color: $theme;
        position: absolute;
        left: 0;
        top: 0;
      }
      .post {
        width: 100%;
        height: 240px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
      .bottom {
        padding: 12px 23px;

        &::after {
          content: "";
          display: block;
          clear: both;
        }
        .title {
          font-size: 20px;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .data {
          float: left;
          padding: 2px 10px;
          border-radius: 7px;
          border: 1px solid $theme;
          display: flex;
          align-items: center;

          .icon {
            width: 18px;
          }
          .num {
            margin-left: 5px;
            font-size: 25px;
            color: $theme;
          }
        }
        .data2 {
          float: right;
        }
      }
    }
  }
}
.new {
  padding: 80px 0 120px;
  background-color: #f1f5f9;

  .content {
    width: $-width;
    margin: 60px auto 0;
    display: flex;

    #news {
      // 图片比例 1112 * 960；非该比例的图完整显示，不裁切
      width: 556px;
      height: 480px;
      flex-shrink: 0;
      overflow: hidden;
      position: relative;

      .swiper-wrapper,
      .swiper-slide {
        height: 100%;
      }
      .swiper-slide {
        cursor: pointer;
      }
      .banner {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        background-color: #f1f5f9;
      }
      .title {
        width: 100%;
        padding: 10px;
        color: #fff;
        background-color: rgba($color: #000, $alpha: 0.5);
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .new-list {
      margin-left: 60px;
      flex-grow: 1;

      .item {
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 19px 0;
        border-bottom: 1px solid #ccc;

        &:hover {
          color: $theme;
          cursor: pointer;
        }
        .title {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .time {
          color: #999;
          margin-left: 10px;
          flex-shrink: 0;
        }
      }
    }
  }
}
.link {
  padding: 60px 0;

  .content {
    width: 1200px;
    margin: 40px auto 0;

    .item {
      padding: 5px 10px;
      font-size: 18px;
      color: #333;

      & + .item {
        margin-left: 10px;
      }
      &:hover {
        color: $theme;
        text-decoration: underline;
      }
    }
  }
}

.m-frame {
  #banner {
    height: 165px;
  }
  .title-box {
    width: 100%;
    text-align: center;

    &::after {
      display: none;
    }
    .title-img {
      height: 25px;
    }
    .sub {
      font-size: 18px;
    }
  }
  .service {
    padding: 20px 0;

    .list {
      width: 90vw;
      margin: 40px auto 0;

      .item {
        height: 200px;
        padding: 0 10px !important;

        img {
          height: 50px;
        }
        .title {
          font-size: 18px;
          margin-bottom: 20px;
        }
        .tip {
          display: none;
        }
        a {
          width: 80%;
        }
        .btn {
          width: 100%;
          font-size: 14px;
          padding: 6px 0;
        }
      }
    }
  }
  .intro {
    padding: 1px 0 40px;

    .title-box {
      display: none;
    }
    .m-intro-box {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;

      .name {
        font-size: 18px;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .desc {
        width: 55%;
        text-align: justify;
      }
      .more {
        width: 120px;
        height: 30px;
        font-size: 14px;
        margin-top: 20px;
      }
    }
  }
  .power {
    padding: 40px 0;

    .content {
      width: 100%;
      height: auto;
      margin-top: 0;
      flex-wrap: wrap;
      position: relative;

      &::after,
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      &::before {
        width: 90%;
        height: 0;
        border-bottom: 1px solid $theme;
      }
      &::after {
        width: 0;
        height: 100%;
        border-right: 1px solid $theme;
      }
      .dot {
        display: block;
      }
      .item {
        width: 50%;
        padding: 10px 0;
        box-sizing: border-box;
        flex: unset;
        border-left: none;

        .count {
          font-size: 18px;

          span {
            font-size: 33px;
          }
          .topUnit {
            font-size: 18px;
          }
        }
        .type {
          font-size: 16px;
        }
      }
    }
  }
  .cert {
    .cert-bg {
      display: none;
    }
    .cert-imgs {
      display: block;
      width: 100%;
      padding-top: 100px;
      overflow: auto;
      display: flex;

      .cert-img {
        width: 80vw;
        flex-shrink: 0;

        & + .cert-img {
          margin-left: 2px;
        }
      }
    }
    .in {
      height: auto;
      padding: 20px 0;
      box-sizing: border-box;
    }
  }
  .value {
    height: 320px;

    .in {
      width: 100%;
      flex-direction: column;

      .left {
        width: 100%;
        height: unset;
        flex-direction: row;

        .tab {
          height: 110px;
          text-align: center;
          padding: 10px;
          flex-direction: column;

          span {
            font-size: 18px;
          }
          .icon {
            width: 20px;
            transform: rotate(90deg);
          }
        }
      }
      .right {
        margin-left: 0;
        margin-top: 20px;
        flex-grow: unset;

        .tab_content {
          width: fit-content;

          .title {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .sub {
            font-size: 16px;
            margin-bottom: 20px;
          }
          .about {
            width: 120px;
            height: 30px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .case {
    padding: 20px 0;

    .case-list {
      width: 100%;
      margin: 50px 0 20px;
      display: block;

      .item {
        border-radius: 5px;

        & + .item {
          margin-left: 0;
        }
        .good {
          width: 90px;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
        }
        .post {
          height: 190px;
        }
        .bottom {
          padding: 10px 20px;
          background-color: #fff;

          .title {
            font-size: 16px;
          }
          .data {
            .icon {
              width: 12px;
            }
            .num {
              font-size: 16px;
            }
          }
        }
      }
      .more {
        width: 120px;
        height: 30px;
        font-size: 14px;
        background-color: $theme;
        color: #fff;
        display: block;
        margin: 20px auto 0;
      }
    }
  }
  #case {
    padding-bottom: 40px;

    :deep(.swiper-slide) {
      transform: scale(0.9);
      z-index: 10;
    }
    :deep(.swiper-slide-active) {
      transform: scale(1);
      z-index: 10;
    }
  }
  .new {
    padding: 30px 0;

    .content {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 30px 0 0;

      .new-list {
        margin-left: 0;

        .item {
          padding: 0;
          border-radius: 2px;
          margin-bottom: 12px;
          border-bottom: 0;
          box-shadow: 5px 0 29px rgba($color: $theme, $alpha: 0.13);
          justify-content: flex-start;

          .left {
            width: 150px;
            height: 120px;
            object-fit: cover;
            flex-shrink: 0;
          }
          .right {
            width: calc(100vw - 170px);
            padding: 0 12px;
            box-sizing: border-box;

            .title {
              font-size: 17px;
            }
            .time {
              font-size: 14px;
              margin-left: 0;
            }
            .desc {
              height: 38px;
              font-size: 13px;
              color: #999;
              overflow: hidden;
              -webkit-line-clamp: 2;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .more {
        width: 120px;
        height: 30px;
        font-size: 14px;
        background-color: $theme;
        color: #fff;
        display: block;
        margin: 20px auto 0;
      }
    }
    #news {
      display: none;
    }
  }
  .link {
    display: none;
  }
}
</style>
